<!--The Heading sections (Heading + Serach )-->
<div class="row header-section mt-5">

  <div class="col-sm-8 col-xs-12">
    <h4>
      Business Entity Contacts & Coaches
    </h4>
  </div>

  @if (defaults.isMersyAdminBranchExcellenceUser || defaults.isMersyCoachBranchExcellenceUser) {
    <div class="col-sm-4 col-xs-12 flex-right">
      <div class="OrangeButton">
        <button mat-raised-button (click)="openCreateContactPopup(createAction)" title="Create new Contact" class="btn btn-sm button-color-fix">
          {{createAction}} Contact  <mat-icon class="add-button icon-color-fix">add_box</mat-icon>
        </button>
      </div>
      <div class="OrangeButton" >
        <button mat-raised-button (click)="openCreateContactPopup(editAction)" title="Edit / Delete new Contact" class="btn btn-sm button-color-fix">
          {{editAction}} Contact
        </button>
      </div>
    </div>
  }

</div>

<div class="">
  <table mat-table #itemsList
    [dataSource]="dataSource"
    multiTemplateDataRows
    class="mat-elevation-z8 mat-table-custom" id="branchcontact">

    <ng-container matColumnDef="ContactName">
      <th mat-header-cell *matHeaderCellDef> Contact Name </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.ContactName"></p>
      </td>
    </ng-container>
    <ng-container matColumnDef="ContactEmail">
      <th mat-header-cell *matHeaderCellDef> Contact Email </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.ContactEmail"></p>
      </td>
    </ng-container>
    <ng-container matColumnDef="ContactCategory">
      <th mat-header-cell *matHeaderCellDef> Contact Category </th>
      <td mat-cell *matCellDef="let element">
        <p [innerHTML]="element.ContactCategory"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element; let i = dataIndex">
        <button mat-icon-button matTooltip="UnAssign Contact" (click)="onRemoveContact(element.ContactId)">
          <mat-icon>link_off</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="ChangeLog">
      <th mat-header-cell *matHeaderCellDef>Change Log</th>
      <td mat-cell *matCellDef="let element">
        <compact-history-button
          [item]="element"
          tooltip="View Change Log"
          buttonText="Get History"
          (historyClick)="onHistoryDetail($event, 'BranchContact')">
        </compact-history-button>
      </td>
    </ng-container>

    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;"
      class="item">
    </tr>
  </table>
</div>



@if (defaults.isMersyAdminBranchExcellenceUser || defaults.isMersyCoachBranchExcellenceUser) {
  <div class="OrangeButton">
    <button (click)="openAddContactPopup()" type="submit" class="btn button-color-fix pull-right">
      Assign Contact
      <mat-icon class="icon-color-fix">add</mat-icon>
    </button>
  </div>
}
